export default {
    estaCarregando: false,
    lista: [],
    excelList: [],
    totais: {
        total: 0,
        saldo: 0,
    },
    filtros: {
        contato: null,
        forma_pagamento: null,
        situacao: [],
        conta: null,
        data_inicial_vencimento: '',
        data_final_vencimento: '',
        data_inicial_pagamento: '',
        data_final_pagamento: '',
    }
}
